import { useState } from "react";
import styled from "@emotion/styled";
import { AlertIcon } from "./AlertIcon";
import {
  ArrowDropDownLine,
  ArrowDropUpLine,
  grayScale,
  mBody3,
  mBody4,
} from "@teamsparta/design-system";

export const ResultNotice = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Wrapper onClick = {() => setIsOpen(!isOpen)}>
      <TitleContainer>
        <TitleDetail>
          <AlertIcon />
          <Title>국비지원 계좌 한도가 무엇인가요?</Title>
        </TitleDetail>
        {isOpen ? (
          <ArrowDropUpLine size={20} color={"#3A3E41"} />
        ) : (
          <ArrowDropDownLine size={20} color={"#3A3E41"} />
        )}
      </TitleContainer>
      {isOpen && (
        <Description>
          5년간 취업, 이직, 역량 개발에 필요한 훈련을
          <br /> 국민내일배움카드 계좌 한도 내에서 받을 수 있습니다.
          <br /> (일부 대상자에 한해 최대 500만원까지 지원)
        </Description>
      )}
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 8px;

  width: 328px;
  height: fit-content;

  background: #f6f9fa;
  border-radius: 12px;
  cursor: pointer;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TitleDetail = styled.div`
  display: flex;
  gap: 4px;
`;

export const Title = styled.div`
  ${mBody3};
`;

export const Description = styled.p`
  ${mBody4};
  color: ${grayScale.gray80};
  text-align: left;
`;
